import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './keycloak-reset-password.magic.css.js';
import script from './keycloak-reset-password.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{ref:"reset-password-form",staticStyle:{"display":"none"},attrs:{"action":_vm.resetPasswordAction,"method":"post"}},[(_vm.isEmailEnabled)?_c('input',{attrs:{"type":"email","id":"email","name":"username","autocomplete":"off"}}):_c('input',{attrs:{"type":"text","id":"username","name":"username","autocomplete":"off"}})]),_vm._v(" "),(_vm.$t('reset-password.hint'))?_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","content":_vm.$t('reset-password.hint')}}):_vm._e(),_vm._v(" "),(_vm.isEmailEnabled)?_c('magic-ui-form-field',{attrs:{"type":"email","pattern":".*","inputmode":"email","message":_vm.$t('reset-password-request.email.error'),"has-success":!_vm.$v.email.$invalid,"has-error":_vm.$v.email.$error,"placeholder":_vm.$t('reset-password-request.email.placeholder'),"value":(_vm.$v.email.$model)},on:{"blur":function($event){return _vm.$v.email.$touch()},"input":function($event){return _vm.$set(_vm.$v.email, "$model", $event.detail[0])}}}):_c('magic-ui-form-field',{attrs:{"type":"text","pattern":".*","inputmode":"text","message":_vm.$t('reset-password-request.username.error'),"has-success":!_vm.$v.username.$invalid,"has-error":_vm.$v.username.$error,"placeholder":_vm.$t('reset-password-request.username.placeholder'),"value":(_vm.$v.username.$model)},on:{"blur":function($event){return _vm.$v.username.$touch()},"input":function($event){return _vm.$set(_vm.$v.username, "$model", $event.detail[0])}}}),_vm._v(" "),_c('div',{staticClass:"wrapper",attrs:{"part":"wrapper"}},[_c('magic-ui-link',{attrs:{"href":_vm.backToLoginUrl}},[_c('magic-ui-button',{attrs:{"wide":"","hollow":"","variant":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('update-password.action.back-to-login'))}})],1),_vm._v(" "),_c('magic-ui-button',{attrs:{"wide":"","variant":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('reset-password.action.reset'))},on:{"click":_vm.submit}})],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-0d6800bf_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-0d6800bf";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
